import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../utils/api';

// Query Keys
export const cblModuleQueryKeys = {
  all: ['cblModules'],
  lists: (params) => [...cblModuleQueryKeys.all, 'list', params],
  list: (params) => [...cblModuleQueryKeys.lists(params)],
};

// ==================== CBL 모듈 목록 조회 ====================
/**
 * CBL 모듈 목록 조회
 * @param {Object} params - 쿼리 파라미터
 * @param {string} params.ModuleName - 모듈명
 * @param {string} params.Version - 버전
 * @param {string} params.RoutingPath - BaseUrl
 * @param {number} params.Page - 페이지 번호
 * @param {number} params.PageSize - 페이지 크기
 * @param {string} params.OrderBy - 정렬 기준
 * @param {string} params.OrderDirection - 정렬 방향 (asc, desc)
 */
// CBL 모듈 목록 조회
export const useCblModuleList = (params = {}) => {
  return useQuery({
    queryKey: cblModuleQueryKeys.list(params),
    queryFn: async () => {
      const response = await api.get('/drivecore/cblmodule/api/CblModule', { params });
      return response;
    },
  });
};

// ==================== CBL 모듈 추가 ====================
/**
 * CBL 모듈 추가
 * @param {Object} payload - 추가할 CBL 모듈 데이터
 * @param {string} payload.moduleName - 모듈명
 * @param {string} payload.version - 버전
 * @param {string} payload.baseUrl - BaseUrl
 */
export const useCreateCblModule = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload) => {
      return await api.post('/drivecore/cblmodule/api/CblModule', payload);
    },
    onSuccess: () => {
      // CBL 모듈 목록 캐시 무효화
      queryClient.invalidateQueries({ queryKey: cblModuleQueryKeys.all });
    },
  });
};

// ==================== CBL 모듈 삭제 ====================
/**
 * CBL 모듈 삭제
 * @param {string} cblModuleSysId - CBL 모듈 ID
 */
export const useDeleteCblModule = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (cblModuleSysId) => {
      return await api.delete(`/drivecore/cblmodule/api/CblModule/${cblModuleSysId}`);
    },
    onSuccess: () => {
      // CBL 모듈 목록 캐시 무효화
      queryClient.invalidateQueries({ queryKey: cblModuleQueryKeys.all });
    },
  });
};

// ==================== CBL 모듈 수정 ====================
/**
 * CBL 모듈 수정
 * @param {string} cblModuleSysId - CBL 모듈 ID
 * @param {Object} payload - 수정할 CBL 모듈 데이터
 * @param {string} payload.moduleName - 모듈명
 * @param {string} payload.version - 버전
 * @param {string} payload.baseUrl - BaseUrl
 * @param {string} payload.modifierSysId - 수정자 시스템 ID
 */
export const useUpdateCblModule = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ cblModuleSysId, payload }) => {
      return await api.put(`/drivecore/cblmodule/api/CblModule/${cblModuleSysId}`, payload);
    },
    onSuccess: () => {
      // CBL 모듈 목록 캐시 무효화
      queryClient.invalidateQueries({ queryKey: cblModuleQueryKeys.all });
    },
  });
};